<template>
<div class="bahasa">
    <div class="uk-container">
        <router-link to="/privacy/english" style="color : black">English </router-link> | <router-link to="/privacy/bahasa" style="color : black">Bahasa </router-link><br><br>
        <div class="uk-flex-center@m">
            <center>
                <h3><b>PLATFORM PRIVACY POLICY</b></h3>
                <h3><b>PT. SUMBER MEDIA KOMUNIKASI </b></h3>
            </center>
            <p>This Privacy Policy explains how information about you is obtained and processed by PT. Sumber Digital Media (SMK) and provides other important information about privacy, and explains when and how we can change this Privacy Policy. We are committed to always protecting the personal data of our customers and we have implemented the steps necessary to maintain the security of your personal data.</p>
            <p>This Privacy Policy applies to the processing of Personal Data by SMK when you use our network, visit our website, and when you use or receive our products and / or services.</p>
            <p>For the purposes of this Privacy Policy: <br>
                "Personal Data" is any information related to SMK customers that is given by customers to SMK or available to SMK due to a customer contract with SMK, for example: name, KTP / Passport number, customer transaction information with SMK such as contact information, credit card information / debit and bank accounts, mobile phone locations (to enable connections to our network), browsing history, call records to customer service or service centers and account activity; the words "you" and "customers" include past, current and future SMK customers, including customers of other network providers who work with SMK;</p>
            <h4><b>HOW  INFORMATION ABOUT YOU OBTAINED:</b></h4>
            <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-decimal">
                        <li>To be able to use the network and / or to receive products and / or services we need your Personal Data. Any failure to meet these requirements or any lack of disclosure of Personal Data will prevent us from processing your application, so you cannot enjoy services, features or products.</li>
                        <li>When you register for our products and services, you have given our consent to collect and process (use, process, record, hold, store, provide and disclose) your Personal Data.</li>
                        <li>By continuing to use our network, visiting our website, or using our products and / or services, you have given your consent to us to process your Personal Data. We will keep a record of your agreement as seen in our active customer database.</li>
                        <li>Your Personal Data can be obtained from various activities and sources. Personal Data may be collected, including but not limited, when you fill out an application form, when you contact us to provide questions or requests for assistance, from calls and networks that you make, including from any third party that you authorize and approve to process Personal Data You. Your Personal Data may also be collected from publicly available information sources and when you visit our website and application, participate in surveys, conduct business relationships with us, or when you submit complaints to us.</li>
                        <li>Our Service can record and store data obtained from smart home products used by you. Your Personal Data can also be obtained from smart home products that you use.</li>
                        <li>Your Personal Data will be stored for the purpose of acquisition and processing, or to comply with any internal requirements, regulations and laws.</li>
                    </ul>
                </div>
            </div>
            <h4><b>HOW YOUR INFORMATION TO BE USED:</b></h4>
            <p>We use the information  for various reasons:</p>
            <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-decimal">
                        <li>to assess, validate, and fulfill your purchase request, verify your identity, activate and / or deactivate the services you have requested, including to provide and maintain ongoing services to you;</li>
                        <li>to process your bills and payments, including sending bills, maintaining financial records, assessing or verifying credit / debit card details;</li>
                        <li>to provide you with technical support and maintain a general customer database, including responding to questions and resolving your complaints;</li>
                        <li>to understand your needs and interests, including to identify and recommend products or services that fit your needs, and to develop, improve, or provide personalized products and services, including service offerings and promotions; and </li>
                        <li>To comply with licensing obligations, statutory regulations and other requirements including to fulfill requests from law enforcement, government institutions, including court bodies in investigating and resolving any of your problems or disputes with us, including for defense of allegations against or otherwise involving us.</li>
                    </ul>
                </div>
            </div>
            <h4><b>HOW YOUR INFORMATION TO BE DISCLOSED</b></h4>
            <p>We may disclose your Personal Data to third parties as follows:</p>
            <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-decimal">
                        <li>to institutions that act as contractors who assist us in providing networks, products and / or services to you;</li>
                        <li>to institutions that act as our payment channel for the purpose of maintaining financial records, assessing or verifying credit / debit card details and facilitating payments owed to us;</li>
                        <li>to regulatory agencies, law enforcement institutions and government authorities for the purpose of legal proceedings and compliance with legal requirements or to detect or prevent crime and / or fraud; or</li>
                        <li>to trusted business partners and our strategic partners to send marketing communications about products and / or services to you based on your choices and interests.  </li>
                    </ul>
                </div>
            </div>

            <h4><b>SMK WEBSITE www.roomi.co.id</b></h4>
            <p>We may request standard information such as login IDs, passwords, personal data, contact details and identification numbers for verification purposes for the use of our site. You are recommended not to reveal your login ID and password to access our site to anyone. We will not be responsible for the disclosure of Personal Data if you reveal your login ID and password to someone other than yourself.</p>

            <h4><b>IP ADDRESS AND COOKIES</b></h4>
            <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-decimal">
                        <li>As part of providing internet services and for security purposes, we may collect and manage IP addresses.</li>
                        <li>We may also use information obtained from cookies or other similar technologies to improve the quality of our website, provide recommendations , and fulfill the transactions you have requested. You can configure and personalize your current browser to refuse or delete these cookies. </li>
                    </ul>
                </div>
            </div>

            <h4><b>TERMINATION OF SERVICE</b></h4>
            <p>SMK may terminate the Service unilaterally if the following happens: </p>
             <div class="uk-child-width-expand@s" uk-grid>
                <div>
                     <ul class="uk-list uk-list-hyphen">
                        <li>You do not do the things set out in this Privacy Policy ;</li>
                        <li>You no longer have authority as a legal subject in accordance with applicable legal provisions; or</li>
                        <li>You do not pay Service fees according to agreed conditions </li>
                    </ul>
                </div>
            </div>

            <h4><b>LINKS TO OTHER WEBSITES OR SERVICES  </b></h4>
            <p>If there is a part of our web site that connects you to other web sites, we are not responsible for risks arising from these other web sites because these web sites are not operated under this Privacy Policy.</p>
            <p>We can update this Privacy Policy. Visit our website to see changes to this Privacy Policy. By continuing to communicate with us, use our network, visit our website and / or use or accept our products and / or services, you have agreed to and accepted these updates.</p>

            <h4><b>INDEMNITY </b></h4>
            <p>You are consciously willing to take full responsibility for all actions taken and release SMK and its subsidiaries, affiliates, shareholders, directors, commissioners, SMK employees, from all claims, losses, payments or any costs incurred suffered by you directly or indirectly, as a result of using our Services, including the procedures for the acquisition, use, disclosure and storage of Personal Data as set out in this Privacy Policy.</p>

            <h4><b>DISPUTE RESOLUTION</b></h4>
            <P> If there is a dispute in the future then you agree to resolve it through deliberation and consensus. If the deliberation does not reach consensus within 30 (thirty) days from the date the first deliberation is held, then you agree to settle the dispute through the court and choose a legal and unchanging residence in Badan Arbitrase Nasional Indonesia (BANI Arbitration Center) in Mampang, Jakarta Selatan where decisions will be final and binding.</P>
            <!-- <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-decimal">
                    </ul>
                </div>
            </div> -->
        </div>
        <br>
        <br>
    </div>
</div>
</template>

<script>
export default {
    props: ['productName', 'description', 'features', 'price', 'link', 'img', 'imgScale', 'imgPositionX', 'imgPositionY', 'spesification'],
    data () {
        return {
            product: this.productName,
            image: require('../assets/roomi_web-02.jpg'),
            imagess: require('../assets/Frame 18.jpg'),
        }
    },
    mounted () {
        
    }
}
</script>

<style scoped>
#product-spesification .uk-section {
    padding-bottom: 80px;
}

#top-section {
    border: 1px solid rgb(67, 67, 68);
    border-radius: 10px;
    height: 350px;
}

#product-features {
    padding: 40px 0 40px 40px;
}

#product-features div {
    margin-top: 2vw;
}

#product-features h3 {
    margin-bottom: 0;
    font-size: 20px;
    letter-spacing: .3vw;
    color: rgb(95, 103, 105);
    line-height: normal;
}

#product-features p {
    color: rgb(194, 195, 197);
    letter-spacing: 2px;
    font-weight: 100;
    line-height: 1;
    font-size: 1.1vw;
    margin-bottom: 2.5vw;
}

p.price {
    color: #403f41;
}

#product-features ul {
    padding-left: 0;
    list-style-position: inside;
    margin-bottom: 3vw;
}

#product-features ul li {
    font-size: .70vw;
    margin-bottom: 15px;
}

#product-features a.uk-button {
    border-radius: 10px;
    font-size: 11px;
    letter-spacing: 1px;
}

#trapezoid img {
    width: 100%;
}

@media screen and (max-width: 639px) {
    #top-section {
        height: auto;
        max-height: auto !important;
    }

    #product-features p {
        font-size: 14px;
    }

    #product-features ul li {
        font-size: 10px;
    }

}
</style>